const CHARACTER_PARTY_ROUTE_NAMES = new Set([
  'myCharactersView',
  'combatCharacters',
  'CharacterSheetView',
])

export default function resolvePartyViewerArenaContext({
  route = {},
  fallbackArenaName = '',
  combatArena = null,
} = {}) {
  const routeName = String(route?.name || '').trim()
  const querySlug = String(route?.query?.slug || '').trim()
  const paramSlug = String(route?.params?.slug || '').trim()
  const isCharacterPartyRoute = CHARACTER_PARTY_ROUTE_NAMES.has(routeName)

  return {
    routeName,
    querySlug,
    paramSlug,
    isCharacterPartyRoute,
    slug: isCharacterPartyRoute ? querySlug : paramSlug,
    name: isCharacterPartyRoute
      ? String(fallbackArenaName || '').trim()
      : String(combatArena?.name || '').trim(),
  }
}
